import { PropsWithChildren } from 'react'
import clsx from 'clsx'

import Head from './Head'
import styles from './Page.module.scss'

type PageProps = PropsWithChildren<{
  title?: string
  description?: string
  className?: string
  imageSrc?: string | null
  noIndex?: boolean
  hideBrandName?: boolean
}>

function Page({
  title,
  description,
  children,
  imageSrc,
  className,
  noIndex = false,
  hideBrandName = false,
}: PageProps) {
  return (
    <>
      <Head
        title={title}
        description={description}
        imageSrc={imageSrc}
        noIndex={noIndex}
        hideBrandName={hideBrandName}
      />
      <main className={clsx(styles.mainContainer, className)}>{children}</main>
    </>
  )
}

export default Page

export type { PageProps }
